import { pitchElementWrapVariants } from "./teamPitchElement.css";
import { PitchElementWrapProps } from "./types";

const PitchElementWrap = ({
  variant = "",
  children,
}: PitchElementWrapProps) => (
  <div className={pitchElementWrapVariants[variant]}>{children}</div>
);
export default PitchElementWrap;
